export async function getEditPageDefinitions(token) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/definitions/?fields=countries,business_types,contact_seniorities,contact_functions,employee_bands,revenue_bands,industries`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return {};
  }
}

export async function getAlgorithms(token) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/definitions/?fields=algorithms`,
      {
        method: "GET",
        headers: new Headers({
          Authorization: token,
          Accept: "application/json",
        }),
      }
    );
    return await response.json();
  } catch (error) {
    return {};
  }
}
